import http from "@/services/http";

export async function syncUserGroups(email: any, content_bundles: any) {
  const { data } = await http().post(
    `${window.env.CPAAS_API_LOCATION}/sync-user-groups`,
    {
      email: email,
      content_bundles: content_bundles,
    }
  );
  return data;
}
